<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un Tramite</option>
        <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" value="value">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los Tramite</option>
        <option v-for="Tramite in Tramites" :value="Tramite.TramiteId">{{Tramite.Nombre}}</option>
      </select>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import {mapActions} from 'vuex'
  import axios from 'axios'

  export default
  {
    data(){
      return {
        enumeraciones,
        comun,
        Tramites:[],
        idDelModelo: -1
      }
    },//Data
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number
    },//Props
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_PJ_Catalogo_Establecer046Tramite_TemisCivil", { llave: this.idDelInput, valor: this.idDelModelo });
    },
    methods: {
    CargarCatalogoDeTramites(){
      let peticion = {
        EsPrueba: comun.EsPrueba,
        JuicioId: this.$store.state.PJ_Catalogos_042JuicioId_TemisCivil.valor
      }
      axios.post(api.conexion + api.PJ.catalogos.C046TramitesTemisCivil, peticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.Tramites = respuesta.data.Tramites;
              //Seleccionar el primer trámite n_n
              this.idDelModelo = this.Tramites[0].TramiteId;
              this.cambiaTramiteInicial();
              return respuesta.data.Tramites;
            }
          }).catch(e => {
           console.log("No Hay Respuesta del Servidor" + e);
         });
    },//CargarCatalogoDeTramites
    cambiarDatos(evento) {
          this.idDelModelo = evento.target.value;
          this.$store.dispatch("A_PJ_Catalogo_Establecer046Tramite_TemisCivil", { llave: this.idDelInput, valor: evento.target.value });
          this.$emit("valorParaElPadre", evento);
        },
    cambiaTramiteInicial: function(){
        this.$store.dispatch("A_PJ_Catalogo_Establecer046Tramite_TemisCivil", { llave: this.idDelInput, valor: this.idDelModelo});
        this.$emit("valorParaElPadre", this.idDelModelo);
      }
    },//Methods
    created() {
      this.CargarCatalogoDeTramites();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/046TramitesTemisCivil.vue